module.exports = __webpack_public_path__ + "img/icon-envelope.a15984b1.svg";